import { render } from "./IntroVideoWidget.vue?vue&type=template&id=20167ee8&scoped=true"
import script from "./IntroVideoWidget.vue?vue&type=script&lang=ts"
export * from "./IntroVideoWidget.vue?vue&type=script&lang=ts"

import "./IntroVideoWidget.vue?vue&type=style&index=0&id=20167ee8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20167ee8"

export default script